"use client";

import React, { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import Image from "next/image";

export default function PartnersSlide({ partners = [] }) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: "start",
    slidesToScroll: 6,
  });

  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setPrevBtnEnabled(emblaApi.canScrollPrev());
    setNextBtnEnabled(emblaApi.canScrollNext());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);
  }, [emblaApi, onSelect]);

  return (
    <div className="bg-transparent w-full">
      <div className="relative partner-carousel px-2 pb-3 mt-1 z-10 sm:px-5">
        <div className="embla" ref={emblaRef}>
          <div className="embla__container">
            {partners.map((partner) => (
              <div
                key={
                  partner.id || partner.name || `partner-${partner.thumbnail}`
                }
                className="embla__slide"
              >
                <Image
                  loading="lazy"
                  src={partner.thumbnail || partner.logo || "/images/hitech.png"}
                  className="w-full pointer-events-none"
                  alt={partner.name || "/"}
                  width={150}
                  height={150}
                />
              </div>
            ))}
          </div>
        </div>
        <div className="absolute !top-[115%] !left-[44%] lg:!left-[47%] sm:pl-0 z-[100]">
          <button
            type="button"
            onClick={scrollPrev}
            disabled={!prevBtnEnabled}
            className="fas fa-chevron-left text-4xl !text-black-100/20 hover:!text-black-100 duration-200 cursor-pointer mr-3 disabled:opacity-50 disabled:cursor-not-allowed bg-transparent border-none"
            aria-label="Previous partners"
          />
        </div>
        <div className="absolute !top-[115%] !right-[44%] lg:!right-[47%] sm:pl-0 z-[100]">
          <button
            type="button"
            onClick={scrollNext}
            disabled={!nextBtnEnabled}
            className="fas fa-chevron-right text-4xl !text-black-100/20 hover:!text-black-100 duration-200 cursor-pointer mr-3 disabled:opacity-50 disabled:cursor-not-allowed bg-transparent border-none"
            aria-label="Next partners"
          />
        </div>
      </div>
    </div>
  );
}
